<div id="content_section">
  <div id="content_main" style="margin-right: 320px">
    <div id="content_sidebar" class="container-shadow content-sidebar" style="width: 300px; position: fixed; right: 20px">
      <button (click)="newAppointmentRequest()" *ngIf="allowedNewAppointmentCreation" type="button" class="btn btn-primary btn-sm" style="width: 100%">
        <i class="fas fa-plus-sign"></i>
        &nbsp;New Appointment Request
      </button>
      <hr style="margin-top: 5px; margin-bottom: 5px" />
      <div class="text-center pagination-small-margin">
        <pagination
          [boundaryLinks]="true"
          [totalItems]="appointmentRequestCount"
          (pageChanged)="pageChanged($event)"
          name='search_params_page'
          ngDefaultControl
          [(ngModel)]="search_params.page"
          class="pagination-sm"
          [itemsPerPage]="search_params.per_page"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination
        ><br />
        <span class="label label-primary" *ngIf="appointmentRequestCount != undefined">{{ appointmentRequestCountLabel() }}</span>
      </div>
      <hr style="margin-top: 5px; margin-bottom: 5px" />
      <fieldset>
        <legend>
          Search&nbsp;&nbsp;
          <button class="btn btn-link btn-lg mt-1" (click)="search()" style="padding: 1px; vertical-align: top">
            <i class="fas fa-arrow-circle-right"></i>
          </button>
          <button class="btn btn-secondary btn-sm pull-right float-right" (click)="clear_search()">Clear</button>
        </legend>
        <div class="row">
          <div class="col-md-12" id="search_form" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
            <div class="checkbox">
              <label>
                <input type="checkbox" name='only_checked_out_by_me' ngDefaultControl [(ngModel)]="search_params.only_checked_out_by_me" />
                Only checked out by me
              </label>
            </div>
            <div class="form-group">
              <label>Date Range</label>
              <select class="form-control input-sm" name='date_range' ngDefaultControl [(ngModel)]="search_params.date_range" (ngModelChange)="dateRangeChange($event)">
                <option *ngFor="let dateRange of search_options.date_ranges" [ngValue]="dateRange.range">{{ dateRange.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>From</label>
                    <input type="text" class="form-control input-sm" name='from_date' ngDefaultcontrol [(ngModel)]="search_params.from_date" [appDatepicker]="search_params.from_date" (dateSelected)="search_params.from_date = $event" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label>To</label>
                    <input type="text" class="form-control input-sm" name='to_date' ngDefaultControl [(ngModel)]="search_params.to_date" [appDatepicker]="search_params.to_date" (dateSelected)="search_params.to_date = $event" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Matter</label>
              <app-matter-search [matterId]="search_params.matter_id" [small_input]="true" (matter_id)="search_params.matter_id = $event"></app-matter-search>
            </div>
            <div class="form-group">
              <label>Created By</label>
              <select class="form-control input-sm" name='created_by' ngDefaultcontrol [(ngModel)]="search_params.created_by">
                <option *ngFor="let user of search_options.created_by_users" [value]="user.value">{{ user.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Status</label>
              <select class="form-control input-sm" name='status' ngDefaultControl [(ngModel)]="search_params.status">
                <option *ngFor="let status of search_options.statuses" [value]="status">{{ status }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Order By</label>
              <select class="form-control input-sm" name='order_by' ngDefaultControl [(ngModel)]="search_params.order_by">
                <option *ngFor="let order_by of search_options.order_by" [value]="order_by">{{ order_by }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>In Order Of</label>
              <select class="form-control input-sm" name='in_order_of' ngDefaultControl [(ngModel)]="search_params.in_order_of">
                <option *ngFor="let in_order_of of search_options.in_order_of" [value]="in_order_of">{{ in_order_of }}</option>
              </select>
            </div>
            <div class="form-group">
              <button (click)="search()" class="btn btn-primary btn-sm" style="width: 100%" type="button">Search</button>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="content_inner" style="padding: 0px 20px 10px 20px">
      <div class="container-fluid container-shadow py-3 px-3">
        <div class="page-header">
          <h2>Appointment Requests</h2>
        </div>
        <table class="table table-striped">
          <thead>
            <th style="padding: 8px">Id</th>
            <th style="padding: 8px">Matter</th>
            <th style="padding: 8px">Created By</th>
            <th style="padding: 8px">Status</th>
            <th style="padding: 8px">Location</th>
            <th style="padding: 8px">How Soon</th>
            <th style="padding: 8px">Attendees</th>
            <th style="padding: 8px">Checked out</th>
          </thead>
          <tbody>
            <tr *ngFor="let appointment_request of appointment_requests">
              <td>
                <a [routerLink]="'/appointment_requests/' + appointment_request.id">{{ appointment_request.id }}</a>
              </td>
              <td>
                <a [href]="'/matters/' + appointment_request.matter.id">{{ appointment_request.matter.number }}</a>
              </td>
              <td>
                <div>{{ appointment_request.created_by }}</div>
              </td>
              <td>
                <strong [ngClass]="{ 'text-success': appointment_request.status == 'Scheduled', 'text-danger': appointment_request.status == 'Cancelled' }">{{ appointment_request.status }}</strong>
                <div *ngIf="appointment_request.status == 'Scheduled'">
                  <a [href]="'/events/' + appointment_request.event_id">View</a>
                  |
                  <a [href]="'/events/' + appointment_request.event_id + '/edit'">Edit</a>
                  &nbsp;Event
                </div>
                <div *ngIf="appointment_request.status == 'Making Contact'">
                  {{ appointmentRequestResultCountLabel(appointment_request.appointment_request_results_count) }}
                </div>
              </td>
              <td>
                <div *ngIf="appointment_request.location.highlight">
                  <p *ngIf="appointment_request.type_name.toLowerCase() != 'phone conference'" class="bg-danger text-white mb-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.location.name }}</p>
                  <p *ngIf="appointment_request.type_name.toLowerCase() == 'phone conference'" class="bg-warning mb-1" style="padding-left: 5px; padding-right: 5px">Phone Conference</p>
                </div>
                <div *ngIf="!appointment_request.location.highlight">
                  <p class="bg-info text-white mb-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.location.name }}</p>
                  <p class="bg-success text-white mb-1" style="padding-left: 5px; padding-right: 5px">{{ appointment_request.location.address }}</p>
                </div>
              </td>
              <td>
                <p [ngClass]="{ 'bg-warning': appointment_request.how_soon == 'ASAP', 'text-danger': appointment_request.how_soon == 'Delay 1 Hour', 'text-info': appointment_request.how_soon == 'Whenever Convenient' }" style="padding-left: 5px; padding-right: 5px">
                  {{ appointment_request.how_soon }}
                </p>
                <strong>Created:&nbsp;</strong>{{ appointment_request.created_at }}
              </td>
              <td>
                <p *ngFor="let attendee of appointment_request.attendees" class="mb-1" style="padding-left: 5px; padding-right: 5px; margin-bottom: 3px; border-bottom: 1px solid #aaa">
                  <a [href]="'/contacts/' + attendee.id">{{ attendee.name }}</a>
                </p>
              </td>
              <td>
                <span *ngIf="!appointment_request.checked_out">
                  <span class="text-danger">Not checked out.</span>
                  <br />
                  <button type="button" class="btn btn-primary btn-sm" (click)="checkOutAppointmentRequest(appointment_request)">Check Out</button>
                </span>
                <span *ngIf="appointment_request.checked_out">
                  <span *ngIf="appointment_request.editing_allowed_while_checked_out">
                    <span class="text-primary">
                      Checked out by me on
                      <br />
                      <span class="text-info">{{ appointment_request.checked_out_on }}</span>
                      <br />
                      <button type="button" class="btn btn-warning btn-sm" (click)="releaseCheckOut(appointment_request)">Release Check out</button>
                    </span>
                  </span>
                  <span class="text-primary" *ngIf="!appointment_request.editing_allowed_while_checked_out">
                    Checked out by
                    <br />
                    <span class="text-info">{{ appointment_request.checked_out_by_name }}</span
                    >&nbsp;on
                    <br />
                    <span class="text-info">{{ appointment_request.checked_out_on }}</span>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
